// src/utils/MeslekiDegerler_engine.js

export const calculateMeslekiDegerler = (answers) => {
    if (!answers || Object.keys(answers).length === 0) {
        return { summary: "Veri Yok", chartData: [], topValues: [], risks: [] };
    }

    // Her değer için puan havuzunu sıfırdan başlatıyoruz
    const rawScores = {
        "Kazanç": 0, "Prestij": 0, "Bağımsızlık": 0, "Yaratıcılık": 0, "Sosyal Yardım": 0,
        "Güvenlik": 0, "Liderlik": 0, "Gelişim": 0, "Çeşitlilik": 0, "Esneklik": 0,
        "Estetik": 0, "Tanınma": 0, "Zihinsel Uyarım": 0, "İdealizm": 0, "Sosyal İlişkiler": 0
    };

    // Hangi sorunun hangi değere ait olduğunun haritası (Çapraz doğrulama mantığı)
    const valueMap = {
        1: "Kazanç", 16: "Kazanç",
        2: "Prestij", 17: "Prestij",
        3: "Bağımsızlık", 18: "Bağımsızlık",
        4: "Yaratıcılık", 19: "Yaratıcılık",
        5: "Sosyal Yardım", 20: "Sosyal Yardım",
        6: "Güvenlik", 21: "Güvenlik",
        7: "Liderlik", 22: "Liderlik",
        8: "Gelişim", 23: "Gelişim",
        9: "Çeşitlilik", 24: "Çeşitlilik",
        10: "Esneklik", 25: "Esneklik",
        11: "Estetik", 26: "Estetik",
        12: "Tanınma", 27: "Tanınma",
        13: "Zihinsel Uyarım", 28: "Zihinsel Uyarım",
        14: "İdealizm", 29: "İdealizm",
        15: "Sosyal İlişkiler", 30: "Sosyal İlişkiler"
    };

    // Gelen cevapları (0-4 puan arası) toplayarak havuzları dolduruyoruz
    Object.keys(answers).forEach(qId => {
        const id = parseInt(qId);
        const score = parseInt(answers[qId]);
        
        if (!isNaN(id) && !isNaN(score) && valueMap[id]) {
            rawScores[valueMap[id]] += score;
        }
    });

    // Her bir değerin maksimum alabileceği puan: 8 (Çünkü 2 soru var, max puan 4x2=8)
    // Recharts grafik motoru ve AI için bunu yüzdelik sisteme çeviriyoruz.
    const chartData = Object.keys(rawScores).map(subject => {
        return {
            subject: subject,
            A: Math.round((rawScores[subject] / 8) * 100), // Grafik motorları genelde 'A' veya 'value' anahtarını sever
            fullMark: 100
        };
    });

    // Yüzdelere göre büyükten küçüğe sıralıyoruz
    chartData.sort((a, b) => b.A - a.A);

    // En yüksek puanlı ilk 3 değeri alıyoruz (Altın Kariyer Rotası için)
    const topValues = chartData.slice(0, 3);
    const summaryStr = topValues.map(v => v.subject).join(", ");

// 🌟 ÖĞRENCİYE GÖSTERİLECEK MESLEKİ DEĞER GERİ BİLDİRİMİ
const STUDENT_FEEDBACK_MAP = {

  "Kazanç": {
    headline: "Maddi Kazanç Senin İçin Öne Çıkıyor",
    message:
      "Bir mesleğin sana sunduğu gelir, yaşam standardı ve maddi olanaklar seçimlerinde önemli olabilir. Gelecekte emeğinin karşılığını aldığını hissettiğin ve maddi hedeflerine ulaşabileceğin işler sana daha çekici gelebilir."
  },

  "Prestij": {
    headline: "Saygınlık Senin İçin Öne Çıkıyor",
    message:
      "Yaptığın işin çevren tarafından değer görmesi, saygın bir konumda bulunmak ve mesleğinle gurur duymak senin için önemli olabilir. Sorumluluk ve itibarı yüksek görevler sana daha anlamlı gelebilir."
  },

  "Bağımsızlık": {
    headline: "Bağımsızlık Senin İçin Öne Çıkıyor",
    message:
      "Kendi kararlarını verebilmek, çalışma biçimini belirleyebilmek ve inisiyatif kullanmak senin için önemli olabilir. Fazla kısıtlanmadığın ve kendi yöntemlerini geliştirebildiğin çalışma ortamları sana daha uygun gelebilir."
  },

  "Yaratıcılık": {
    headline: "Yaratıcılık Senin İçin Öne Çıkıyor",
    message:
      "Yeni fikirler üretmek, farklı yollar denemek ve ortaya sana ait bir şey koymak bir işten aldığın doyumu artırabilir. Sürekli aynı şeyleri yapmak yerine hayal gücünü kullanabileceğin alanlar sana daha çekici gelebilir."
  },

  "Sosyal Yardım": {
    headline: "İnsanlara Katkı Sağlamak Senin İçin Öne Çıkıyor",
    message:
      "Yaptığın işin başka insanların hayatında olumlu bir karşılığı olması senin için önemli olabilir. Yardım edebildiğin, bir sorunun çözümüne katkı sunduğun veya topluma fayda sağladığını hissettiğin işler sana daha anlamlı gelebilir."
  },

  "Güvenlik": {
    headline: "Güvence Senin İçin Öne Çıkıyor",
    message:
      "Çalışma hayatında istikrar, düzen ve geleceğini öngörebilmek senin için önemli olabilir. İş koşullarının belirli olduğu ve uzun vadede kendini güvende hissedebileceğin ortamlar sana daha uygun gelebilir."
  },

  "Liderlik": {
    headline: "Liderlik Senin İçin Öne Çıkıyor",
    message:
      "Sorumluluk almak, karar süreçlerinde yer almak ve bir ekibi ortak bir hedefe yönlendirmek sana çekici gelebilir. İnisiyatif kullanabileceğin ve organizasyon yapabileceğin görevler seni daha fazla motive edebilir."
  },

  "Gelişim": {
    headline: "Kendini Geliştirmek Senin İçin Öne Çıkıyor",
    message:
      "Bir meslekte sürekli yeni şeyler öğrenebilmek, becerilerini geliştirmek ve zaman içinde ilerlediğini görmek senin için önemli olabilir. Öğrenme fırsatları sunan ve seni geliştiren işler daha fazla ilgini çekebilir."
  },

  "Çeşitlilik": {
    headline: "Çeşitlilik Senin İçin Öne Çıkıyor",
    message:
      "Her günün birbirine benzemediği, farklı görevlerle karşılaştığın ve zaman zaman yeni ortamlar deneyimlediğin işler sana daha çekici gelebilir. Çok tekrarlı çalışma düzenleri yerine hareket ve değişim seni daha fazla motive edebilir."
  },

  "Esneklik": {
    headline: "Esneklik Senin İçin Öne Çıkıyor",
    message:
      "Çalışma hayatınla kişisel yaşamın arasında denge kurabilmek ve zamanını belirli ölçüde kendin yönetebilmek senin için önemli olabilir. Çalışma saatleri ve yöntemlerinde esneklik sunan işler sana daha uygun gelebilir."
  },

  "Estetik": {
    headline: "Estetik Senin İçin Öne Çıkıyor",
    message:
      "Güzellik, tasarım ve görsel uyum içeren işler sana daha anlamlı gelebilir. Bir ürünü, ortamı veya fikri daha estetik hale getirebildiğin çalışmalar ilgini ve motivasyonunu artırabilir."
  },

  "Tanınma": {
    headline: "Tanınmak ve Takdir Edilmek Senin İçin Öne Çıkıyor",
    message:
      "Yaptığın çalışmaların fark edilmesi, karşılık bulması ve başkaları tarafından takdir edilmesi senin için motive edici olabilir. Ürettiklerini görünür kılabildiğin çalışma alanları sana daha çekici gelebilir."
  },

  "Zihinsel Uyarım": {
    headline: "Zihinsel Zorluk Senin İçin Öne Çıkıyor",
    message:
      "Düşünmeni gerektiren problemlerle uğraşmak, araştırmak, analiz etmek ve yeni çözümler üretmek sana çekici gelebilir. Seni zihinsel olarak aktif tutan ve merakını canlı tutan işler daha fazla ilgini çekebilir."
  },

  "İdealizm": {
    headline: "Bir Amaca Katkı Sunmak Senin İçin Öne Çıkıyor",
    message:
      "Yaptığın işin yalnızca sana değil, çevrene veya daha geniş bir toplumsal amaca da katkı sağlaması senin için önemli olabilir. Değerlerinle uyumlu ve anlamlı bulduğun amaçlara hizmet eden işler sana daha yakın gelebilir."
  },

  "Sosyal İlişkiler": {
    headline: "İyi İnsan İlişkileri Senin İçin Öne Çıkıyor",
    message:
      "Birlikte çalıştığın insanlarla kurduğun ilişkiler ve çalışma ortamının sosyal yapısı senin için önemli olabilir. İş birliği, dayanışma ve sıcak iletişim bulunan ekiplerde kendini daha rahat hissedebilirsin."
  }
};


const primaryValue = topValues[0];
const dominantFeedback =
  STUDENT_FEEDBACK_MAP[primaryValue?.subject];

const studentFeedback = {
  eyebrow: "MESLEKİ DEĞER PROFİLİN",

  title: "Bir İşte Senin İçin Neler Önemli?",

  headline:
    dominantFeedback?.headline ||
    "Mesleki Değerlerinden Biri Öne Çıkıyor",

  highlights: topValues.map(item => item.subject),

  message:
    dominantFeedback?.message ||
    "Yanıtların, gelecekte bir meslekten ve çalışma ortamından neler beklediğin hakkında bazı ipuçları veriyor.",

  counselorNote:
    "Bu sonuç sana tek başına hangi mesleği seçmen gerektiğini söylemez. Meslek seçimini yaparken değerlerini; ilgi alanların, öğrenme ve güçlü yönlerin, kişisel özelliklerin ve eğitim seçeneklerinle birlikte değerlendirmen daha sağlıklı olur.",

  btnText: "Değerlerimi Gördüm"
};

   // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  // Mesleki Değerler bir "Risk" testi değil, Kariyer "Profil" testidir.
  // En baskın değerin eşleşme yüzdesini riskScore olarak iletiyoruz.
  const topPercentage = chartData.length > 0 ? chartData[0].A : 0;

  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: topPercentage, // En yüksek değerin motivasyon yüzdesi
    masterRisk: "none",       // Radar ekranında acil uyarı vermemesi için
    isCritical: false, 
    domain: "profile",        // Bu bir profil/değerler testi

    // 2. Mevcut Detaylı Veriler (Dashboard, Pusula ve PDF için dokunmadık)
    scores: rawScores,
    chartData: chartData,
   topValues: topValues,
summary: `Baskın Kariyer Motivasyonları: ${summaryStr}`,

// 🌟 Öğrenci test sonrası kişisel geri bildirimi
studentFeedback: studentFeedback,

risks: [],
colorCode: "emerald"
  };
};